var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-carousel',{staticClass:"sliders",attrs:{"interval":3000,"height":_vm.clientHeight,"autoplay":true}},_vm._l((4),function(index){return _c('el-carousel-item',{key:index,staticClass:"slider-item",style:({backgroundImage: ("url('https://djqsmiqswxrv8.cloudfront.net/joy2ever/web/home_" + index + ".png')")})})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a97e7256","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = null
// module chunks = 